// Settings persistidas em localStorage, aplicadas ao vivo (docs/06).
export interface Settings {
  sens: number;      // escala do CS (graus = counts * sens * 0.022)
  fov: number;       // 90..130
  volMaster: number; // 0..100
  volWind: number;
  volSfx: number;
  volMusic: number;
  viewRoll: boolean;
  landBob: boolean;
}

export const DEFAULT_SETTINGS: Settings = {
  sens: 2.5,
  fov: 105,
  volMaster: 80,
  volWind: 70,
  volSfx: 100,
  volMusic: 40,
  viewRoll: true,
  landBob: true,
};

const KEY = 'surfrun.settings.v1';

export function loadSettings(): Settings {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULT_SETTINGS };
    return { ...DEFAULT_SETTINGS, ...(JSON.parse(raw) as Partial<Settings>) };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveSettings(s: Settings): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(s));
  } catch { /* storage indisponível — segue com defaults em memória */ }
}
